import { api } from 'app/config/apiConfig';
import { AuthResponse, getMeApi, userActions } from 'entities/User';
import i18n from 'app/config/i18Config/i18n';
import { showNotification } from 'app/providers/NotificationsProvider';

export const vkAuthApi = api.injectEndpoints({
  endpoints: (build) => ({
    vkAuth: build.mutation<AuthResponse, string>({
      query: (token) => ({
        url: '/authorization/vk-login',
        method: 'POST',
        body: { token },
      }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        try {
          const vkAuthResponse = await queryFulfilled;

          dispatch(userActions.setCredentials({ credentials: vkAuthResponse.data, remember: true }));

          const getMeResponse = await dispatch(getMeApi.endpoints.getMe.initiate()).unwrap();

          dispatch(userActions.setUserData(getMeResponse));
        } catch (error) {
          showNotification('error', i18n.t('Error', { ns: 'common' }), i18n.t('Error when authorization via VK', { ns: 'common' }));
        }
      },
    }),
  }),
});

export const { useVkAuthMutation } = vkAuthApi;
